import { Link } from "react-router-dom";

// Short final-sale notice used near every pallet purchase option + at checkout.
export const PalletFinalSale = ({ compact = false }) => (
  <div
    className={`border-2 border-red-600 bg-red-50 ${compact ? "p-3" : "p-4"}`}
    data-testid="pallet-final-sale-notice"
  >
    <div className="font-black text-red-700 text-sm tracking-wide">ALL PALLET SALES ARE FINAL</div>
    <p className="text-xs text-red-900/90 mt-1 leading-relaxed">
      Pallet merchandise is sold under our{" "}
      <Link to="/policies/pallets" target="_blank" className="underline font-bold" data-testid="pallet-policy-link">
        Pallet Sales Policy
      </Link>
      . No returns, exchanges, or cash refunds. Manifested pallets may qualify for limited store credit on
      eligible defective items when reported within 48 hours with required photos. Unmanifested and custom
      merchandise is sold AS-IS unless otherwise stated in writing.
    </p>
  </div>
);
